"use strict";
/**
 *
 *
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var Observable_1 = require("./Observable");
var next_tick_1 = __importDefault(require("next-tick"));
// import 'reflect-metadata';
function disposeAll(subscriptions) {
    while (subscriptions.length) {
        if (subscriptions[0]) {
            subscriptions[0].dispose();
        }
        subscriptions.splice(0, 1);
    }
}
exports.disposeAll = disposeAll;
function shallowDiffers(a, b) {
    for (var i in a)
        if (!(i in b))
            return true;
    for (var i in b)
        if (a[i] !== b[i])
            return true;
    return false;
}
var DepsWatcher = /** @class */ (function () {
    function DepsWatcher(callback) {
        this._deps = {};
        this._depsSubscriptions = {};
        this._depsModels = {};
        this._callback = callback;
    }
    DepsWatcher.prototype.addDependency = function (depId, dep, doImmediateNotify) {
        var _this = this;
        if (doImmediateNotify === void 0) { doImmediateNotify = true; }
        if (this._deps[depId] === dep) {
            // did not change
            return;
        }
        if (this._deps[depId]) {
            this.removeDependency(depId, false);
        }
        this._deps[depId] = dep;
        this._depsSubscriptions[depId] = dep.subscribeUpdates(function (model) {
            _this._updateDependencyModel(depId, model);
        });
        this._updateDependencyModel(depId, dep.getModel(), doImmediateNotify);
    };
    DepsWatcher.prototype.removeDependency = function (depId, doImmediateNotify) {
        if (doImmediateNotify === void 0) { doImmediateNotify = true; }
        if (!this._deps[depId]) {
            return;
        }
        this._depsSubscriptions[depId].dispose();
        delete this._depsSubscriptions[depId];
        this._deps[depId].release();
        delete this._deps[depId];
        this._updateDependencyModel(depId, null, doImmediateNotify);
    };
    DepsWatcher.prototype._updateDependencyModel = function (depId, model, doNotify) {
        if (doNotify === void 0) { doNotify = true; }
        var prevDepModels = this._depsModels;
        this._depsModels = __assign({}, this._depsModels); // shallow clone
        if (model != null) {
            this._depsModels[depId] = model;
        }
        else {
            delete this._depsModels[depId];
        }
        if (doNotify) {
            this._callback(this._depsModels, prevDepModels);
        }
    };
    DepsWatcher.prototype.getDepsModels = function () {
        return this._depsModels;
    };
    DepsWatcher.prototype.dispose = function () {
        var depIds = Object.keys(this._deps);
        for (var _i = 0, depIds_1 = depIds; _i < depIds_1.length; _i++) {
            var depId = depIds_1[_i];
            this.removeDependency(depId, false);
        }
    };
    return DepsWatcher;
}());
var BaseService = /** @class */ (function (_super) {
    __extends(BaseService, _super);
    function BaseService(initialModel) {
        var _this = _super.call(this) || this;
        _this._model = null;
        _this._subscriptions = [];
        _this._model = initialModel != null ? initialModel : _this._createInitialModel();
        // TODO: subscribe on deps
        // onDepsUpdated:
        // check deps.errors, loading, ...
        _this._depsWatcher = new DepsWatcher(function (newModels, prevModels) {
            _this._onDepsUpdated(newModels, prevModels);
        });
        next_tick_1["default"](function () {
            _this._initializedInstance = _this;
            if (_this._hDepsModels) {
                var prevDepsModels_1 = {};
                Object.keys(_this._hDepsModels).forEach(function (depId) { return (prevDepsModels_1[depId] = null); });
                _this._onDepsUpdated(_this._hDepsModels, prevDepsModels_1);
            }
        });
        return _this;
    }
    BaseService.prototype._createInitialModel = function () {
        return { loading: true, error: null };
    };
    // adds dependency and notify by call _onDepsUpdated
    BaseService.prototype._addDependency = function (depId, dep, doImmediateNotify) {
        if (doImmediateNotify === void 0) { doImmediateNotify = true; }
        this._depsWatcher.addDependency(depId, dep, doImmediateNotify);
    };
    BaseService.prototype._addDependencies = function (deps, doImmediateNotify) {
        if (doImmediateNotify === void 0) { doImmediateNotify = true; }
        var prevDepsModels = this._depsWatcher.getDepsModels();
        for (var _i = 0, _a = Object.keys(deps); _i < _a.length; _i++) {
            var depId = _a[_i];
            this._depsWatcher.addDependency(depId, deps[depId], false);
        }
        if (doImmediateNotify)
            this._onDepsUpdated(this._depsWatcher.getDepsModels(), prevDepsModels);
    };
    BaseService.prototype._removeDependency = function (depId, doImmediateNotify) {
        if (doImmediateNotify === void 0) { doImmediateNotify = true; }
        this._depsWatcher.removeDependency(depId, doImmediateNotify);
    };
    BaseService.prototype._onDepsUpdated = function (newModels, prevModels) {
        var depIds = Object.keys(newModels);
        var newDepsModels = depIds
            .map(function (depId) { return newModels[depId]; })
            .filter(function (model) { return model !== null; });
        var errorModel = newDepsModels.find(function (depModel) { return !!depModel.error; });
        if (errorModel) {
            this._updateWithError(errorModel.error);
            return false;
        }
        var loadingModel = newDepsModels.find(function (depModel) { return !!depModel.loading; });
        if (loadingModel) {
            this._updateWithLoading();
            return false;
        }
        this._onDepsReadyAndUpdated(newModels, prevModels);
        return true;
    };
    // want override
    BaseService.prototype._onDepsReadyAndUpdated = function (newModels, prevModels) {
        //
    };
    BaseService.prototype._getDependencyModel = function (depId) {
        return this._depsWatcher.getDepsModels()[depId] || null;
    };
    BaseService.prototype._updateWithLoading = function () {
        this._updateModel({ loading: true, error: null });
    };
    BaseService.prototype._updateWithError = function (error) {
        this._updateModel({ loading: false, error: error });
    };
    BaseService.prototype._updateWithData = function (partialModel) {
        this._updateModel(__assign({ loading: false, error: null }, partialModel));
    };
    BaseService.prototype._smartUpdate = function (newModel, prevModel) {
        return newModel;
    };
    // may override for clever comparision
    BaseService.prototype._isModelChanged = function (nextModel, currentModel) {
        if (currentModel == nextModel)
            return false;
        if (!currentModel && !nextModel)
            return false; // both ~false
        if (!currentModel && nextModel)
            return true; // one ~false, other exists
        if (currentModel && !nextModel)
            return true;
        return shallowDiffers(nextModel, currentModel);
    };
    BaseService.prototype._setModel = function (model) {
        if (!this._isModelChanged(model, this._model)) {
            // do not update the value if nothing changed
            // this._model = this._smartUpdate(model, this._model);
            return;
        }
        this._model = this._smartUpdate(model, this._model);
        this._notify('update', this._model);
        if (this.isReady()) {
            this._notify('ready', this._model);
        }
    };
    BaseService.prototype._updateModel = function (partialModel) {
        this._setModel(__assign(__assign({}, this._model), partialModel));
    };
    /**
     * Returns if service is ready and has data
     *
     * @returns {boolean}
     */
    BaseService.prototype.isReady = function () {
        if (this._model == null) {
            // debugger;
        }
        return !this._model.error && !this._model.loading;
    };
    /**
     * Wait until service in state 'ready' (which means, no error and no loading)
     * return Promise<MODEL>
     *
     * if model signal error, it rejects resulting promise
     *
     * @returns {Promise<MODEL>}
     */
    BaseService.prototype.whenReady = function () {
        var _this = this;
        return this.lock(function () {
            if (_this._model.error) {
                return Promise.reject(_this._model.error);
            }
            if (_this.isReady()) {
                return Promise.resolve(_this._model);
            }
            return new Promise(function (resolve, reject) {
                if (_this._model.error) {
                    reject(_this._model.error);
                    return;
                }
                if (_this.isReady()) {
                    resolve(_this._model);
                    return;
                }
                var subscription = _this.subscribe('update', function (model) {
                    if (model.error) {
                        subscription.dispose();
                        reject(model.error);
                    }
                    else if (_this.isReady()) {
                        subscription.dispose();
                        resolve(model);
                    }
                });
                // return this.happens('ready');
            });
        });
    };
    BaseService.prototype.subscribeAndNotify = function (event, listener) {
        try {
            listener(this._model);
        }
        catch (err) {
            console.error(err);
        }
        return this.subscribe(event, listener);
    };
    BaseService.prototype.subscribeUpdates = function (listener) {
        return this.subscribe('update', listener);
    };
    BaseService.prototype.subscribeUpdatesAndNotify = function (listener) {
        return this.subscribeAndNotify('update', listener);
    };
    BaseService.prototype.getModel = function () {
        return this._model;
    };
    // dangerous
    BaseService.prototype._releaseChild = function (name) {
        if (!(name in this)) {
            console.error("BaseService::_releaseChild: child " + name + " not found in", this);
            throw new Error("BaseService::_releaseChild: child " + name + " not found in " + this);
        }
        if (this[name] != null) {
            this[name].release();
            this[name] = null;
        }
    };
    BaseService.prototype._dispose = function () {
        this._initializedInstance = false;
        disposeAll(this._subscriptions);
        this._subscriptions = null;
        this._depsWatcher.dispose();
        this._depsWatcher = null;
        // remove hDependencies
        while (this._hDependenciesNames && this._hDependenciesNames.length) {
            var name_1 = this._hDependenciesNames.pop();
            this[name_1] = null;
        }
        this._hDepsModels = {};
        this._model = null;
        _super.prototype._dispose.call(this);
    };
    BaseService.dependency = function (target, key, descriptor) {
        // if (descriptor === undefined) {      // in case of property assignment
        //   const clazz = Reflect.getMetadata('design:type', target, key);
        //   let instance;
        //   if (clazz.getInstance()) {
        //     instance = clazz.getInstance();
        //   } else {
        //     throw new Error('No getInstance method');
        //   }
        //
        //   Object.defineProperty(target, key, {
        //     get: () => instance,
        //     // set: function (v) { return value = safeMemWrap(v, this); },
        //     enumerable: true,
        //   });
        //
        //   if (!target._hDeps) target._hDeps = [];
        //   target._hDeps.push(instance.retain());
        //
        //   return null;
        // }
        var depId = key.replace(/^_/, '').replace(/(Service|VC)$/, '');
        if (true /*descriptor === undefined*/) {
            // in case of property assignment
            // add _initialized member to BaseService instance (__proto__)
            if (!('_initializedInstance' in target)) {
                var initializedInstance_1 = false;
                Object.defineProperty(target, '_initializedInstance', {
                    get: function () { return initializedInstance_1; },
                    set: function (v) { return (initializedInstance_1 = v); },
                    enumerable: true
                });
            }
            if (!target._hDependenciesNames)
                target._hDependenciesNames = [];
            if (!target._hDepsModels)
                target._hDepsModels = {};
            target._hDependenciesNames.push(key);
            target._hDepsModels[depId] = null;
            var instance_1 = null;
            var onUpdate_1 = function (model) {
                var prevDepsModels = __assign({}, target._hDepsModels);
                target._hDepsModels[depId] = model;
                // notify updates only after initialization complete
                if (target._initializedInstance) {
                    target._initializedInstance._onDepsUpdated(target._hDepsModels, prevDepsModels);
                }
            };
            Object.defineProperty(target, key, {
                get: function () { return instance_1; },
                set: function (v) {
                    if (instance_1 !== v) {
                        if (instance_1) {
                            instance_1.unsubscribe(onUpdate_1);
                            if (!('getInstance' in instance_1.constructor))
                                instance_1.release();
                        }
                        instance_1 = v;
                        if (instance_1) {
                            instance_1.subscribeUpdatesAndNotify(onUpdate_1);
                        }
                        else {
                            onUpdate_1(null);
                        }
                    }
                    return v;
                },
                enumerable: true
            });
            return;
        }
        throw new Error('Not implemented');
    };
    return BaseService;
}(Observable_1.Observable));
exports.BaseService = BaseService;
